import axios from 'axios';

import { parseResponseError } from 'common/helpers';
import { ResponseError } from 'models';

import {
    requestAssignmentPreference,
    requestCreateTicket,
    requestCreateTicketDraft,
    requestDeleteTicketDraft,
    requestTicketCreationOptions,
    requestTicketDraft,
    requestTicketDrafts,
    requestUpdateTicketDraft,
    requestWorkGroupUsers
} from '../datasources/ticketCreation.datasource';
import { CreateTicketRequest, SaveTicketDraftRequest } from '../schemas';

function normalizeError(error: unknown): Error {
    const responseError = parseResponseError(error) as ResponseError | null;
    return new Error(responseError?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
}

export async function getTicketCreationOptions(linkId: string) {
    try {
        return (await requestTicketCreationOptions(linkId)).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function getWorkGroupUsers(
    linkId: string,
    workGroupCode: string,
    signal?: AbortSignal
) {
    try {
        return (await requestWorkGroupUsers(linkId, workGroupCode, signal)).data;
    } catch (error) {
        if (axios.isCancel(error)) throw error;
        throw normalizeError(error);
    }
}

export async function getAssignmentPreference(
    workGroupCode: string,
    signal?: AbortSignal
) {
    try {
        return (await requestAssignmentPreference(workGroupCode, signal)).data;
    } catch (error) {
        if (axios.isCancel(error)) throw error;
        throw normalizeError(error);
    }
}

export async function createTicket(payload: CreateTicketRequest) {
    try {
        return (await requestCreateTicket(payload)).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function getTicketDrafts() {
    try {
        return (await requestTicketDrafts()).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function getTicketDraft(draftId: string) {
    try {
        return (await requestTicketDraft(draftId)).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function createTicketDraft(payload: SaveTicketDraftRequest) {
    try {
        return (await requestCreateTicketDraft(payload)).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function updateTicketDraft(draftId: string, payload: SaveTicketDraftRequest) {
    try {
        return (await requestUpdateTicketDraft(draftId, payload)).data;
    } catch (error) {
        throw normalizeError(error);
    }
}

export async function deleteTicketDraft(draftId: string) {
    try {
        await requestDeleteTicketDraft(draftId);
    } catch (error) {
        throw normalizeError(error);
    }
}
